import React from 'react'

const ContactUs = () => {
  return (
    <div>
      <div className='text-center'>
        <h2 className="businessTitle text-center ff-renner-bold">
          Ready to get started?
        </h2>
        <div className='align-self-center d-flex justify-content-center'>
          <div className='line text-primary bg-primary mt-4' />
        </div>
      </div>
      <div className='mt-4'>
        <h4 className='ff-renner-book text-center'>
          Our product experts are available to answer any questions you might have.
        </h4>
      </div>
      <div className='d-flex justify-content-center align-self-center mt-4'>
        <button className='cw-btn cw-btn-primary ff-renner-book' onClick={() => window.open(`https://about.crediwatch.com/contact/contact-us/`)}>Contact Us</button>
      </div>
      <div className=" mt-5 p-2">
        <div className="fs-14 text-center ff-renner-book">*Crediwatch is a credit risk intelligence and analytics company and 
        <span className='ff-renner-bold'> DOES NOT PROVIDE</span> loans or disburse any kind including physical or digital loans</div>
      </div>
      <div className='gap-between-section' />
    </div>
  )
}

export default ContactUs